import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import PlaceIcon from '@mui/icons-material/Place';
import Loading from '../loading';
import GeoLocModal from '../Modals/GeoLoc';

const adminOptions = [
    { value: 0, label: 'User' },
    { value: 10, label: 'Admin' }
];

const UserManage = ({ currentUser, setCurrentUser, socket }) => {

    const [loading, setLoading] = useState(true);

    const [users, setUsers] = useState([]);

    const [user, setUser] = useState({});

    if (loading) {
        let payload = {
            requestor: currentUser.user,
            jwt: localStorage.getItem('auth_token'),
            ip: localStorage.getItem('ip')
        }
        socket.emit('load users', payload);
        socket.on('users loaded', data => {
            setUsers(data);
            setLoading(false);
        });
    }

    const handleSubmit = e => {
        e.preventDefault();
        let payload = {
            user,
            requestor: currentUser.user,
            jwt: localStorage.getItem('auth_token')
        }
        socket.emit('update user', payload);
    }

    const [geoData, setGeoData] = useState({
        user: {},
        show: false
    })

    return (
        <Box sx={{ mt: 3 }}>
            <Typography variant="h4" align="center" gutterBottom>Edit Users</Typography>
            {!loading ? (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Callsign</TableCell>
                                <TableCell>First Name</TableCell>
                                <TableCell>Last Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Admin Level</TableCell>
                                <TableCell>Geo</TableCell>
                                <TableCell>Update</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map(u => {
                                const editable = u.isAdmin > 8;
                                return (
                                    <TableRow key={u._id}>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                onChange={e => setUser({ ...u, username: e.target.value })}
                                                defaultValue={u.username}
                                                disabled={!editable}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                onChange={e => setUser({ ...u, firstName: e.target.value })}
                                                defaultValue={u.firstName}
                                                disabled={!editable}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                onChange={e => setUser({ ...u, lastName: e.target.value })}
                                                defaultValue={u.lastName}
                                                disabled={!editable}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                onChange={e => setUser({ ...u, email: e.target.value })}
                                                defaultValue={u.email}
                                                disabled={!editable}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ minWidth: 140 }}>
                                            <Autocomplete
                                                size="small"
                                                disableClearable
                                                options={adminOptions}
                                                defaultValue={adminOptions.find(a => a.value === u.isAdmin) ?? null}
                                                onChange={(e, value) => setUser({ ...u, isAdmin: value.value })}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={() => setGeoData({ show: true, user: u })} size="small">
                                                <PlaceIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell>
                                            <Button variant="contained" size="small" onClick={handleSubmit}>Update</Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                    <GeoLocModal
                        geoData={geoData}
                        setGeoData={setGeoData}
                    />
                </TableContainer>
            ) : (
                <Loading />
            )}
        </Box>
    )
};

export default UserManage;
